type DevicePerformance = {
  memory: number;
  cores: number;
  dpr: number;
  score: number;
  isHighEnd: boolean;
};

export function useDevicePerformance(): DevicePerformance {
  // 兼容性类型断言，避免TS报错
  const memory =
    (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 1;
  const cores = navigator.hardwareConcurrency ?? 2;
  const dpr = window.devicePixelRatio ?? 1;

  // 简单基准测试
  const benchmark = () => {
    const start = performance.now();
    for (let i = 0; i < 1e6; i++) Math.sqrt(i);
    return performance.now() - start;
  };

  const cost = benchmark();
  return {
    memory,
    cores,
    dpr,
    score: cost,
    isHighEnd: memory > 4 && cores >= 8 && cost < 100 && dpr > 2,
  };
}
